import {
  projectHealth,
  HEALTH_LABEL,
  HEALTH_COLOR,
  type Health,
} from "@/lib/projectHealth";

type P = {
  status: string;
  targetDate?: string | number | null;
  completedCount?: number;
  totalCount?: number;
  healthOverride?: Health | null;
  healthReason?: string | null;
};

/**
 * Project health pill (green/amber/red) with a tooltip explaining the inputs.
 * A manual override wins over the computed signal and is noted in the tooltip.
 */
export function HealthBadge({
  project,
  showLabel = true,
}: {
  project: P;
  showLabel?: boolean;
}) {
  const { health, reason, overridden } = projectHealth({
    status: project.status,
    targetDate:
      typeof project.targetDate === "number"
        ? null
        : (project.targetDate ?? null),
    completedCount: project.completedCount ?? 0,
    totalCount: project.totalCount ?? 0,
    healthOverride: project.healthOverride ?? null,
    healthReason: project.healthReason ?? null,
  });
  return (
    <span
      className="health-badge"
      title={`${HEALTH_LABEL[health]} — ${reason}${overridden ? " (manual override)" : ""}`}
    >
      <span
        className="health-dot"
        style={{ background: HEALTH_COLOR[health] }}
      />
      {showLabel && (
        <span className="health-label">{HEALTH_LABEL[health]}</span>
      )}
    </span>
  );
}
